import { GetterTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import { CategoryReviewState } from '../types/CategoryReview'

const getters: GetterTree<CategoryReviewState, RootState> = {
  categoryId: (state) => state.categoryId,
  reviews: (state) => state.items,
  totalCount: (state) => state.totalCount,
  averageRating: (state) => state.averageRating,
  pageCount: (state) => Math.ceil(state.totalCount / state.pageSize),
  currentPage: (state) => state.currentPage
}

export default getters
